/*
 * This file contains all the constants used in the ServiceDesk front-end.
 * Adjust the values as necessary.
 */


// MFA status checking constants
export const POLLING_INTERVAL = 15000;  // 15 sec, interval to check the MFA status
export const MAX_RETRY_COUNT = 20;      // Safeguard to prevent infinite loop. 15 sec * 20 times = 300 sec = 5 min; API should time out before reaching this limit

